module.exports = __webpack_public_path__ + "img/Oakland City Station Concepts_Page_1.a93fba44.jpg";